module.exports = __webpack_public_path__ + "static/media/china.9677bcae.png";